import { useCallback, useEffect } from "react";

import { useMsal } from "@azure/msal-react";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import permissionCloudSrc from "assets/icons/permission-cloud.svg";
import { Button, LogOut01Icon, SEO, Typography } from "components";
import { Paths, QueryClientGlobal, UseLoginLocal } from "configs";
import { alert, confirm } from "contexts";
import { usePushRoute } from "hooks";
import { authLogoutService } from "services";
import { useAppDispatch, useAppSelector } from "stores";
import { authSlice } from "stores/Auth";
import { systemSlice } from "stores/System";
import { i18n } from "translations";
import { rem } from "utils";

const IndexPage = () => {
  const theme = useTheme();
  const lgUpMatched = useMediaQuery(theme.breakpoints.up("lg"));
  const dispatch = useAppDispatch();
  const { pushRoute } = usePushRoute();
  const { instance } = useMsal();
  const organizations = useAppSelector(
    (state) => state?.auth?.organizations || []
  );

  useEffect(() => {
    if (organizations?.length) {
      pushRoute({}, Paths.TimeAttendance);
    }
  }, [organizations, pushRoute]);

  const handleLogout = useCallback(() => {
    confirm({
      title: i18n.t("logout"),
      content: i18n.t("doYouWantToLogout"),
      okLabel: i18n.t("logout"),
    })
      .then(() => {
        authLogoutService()
          .then(() => {
            QueryClientGlobal?.clear();
            dispatch(authSlice.actions.logout());
            dispatch(systemSlice.actions.reset());

            if (UseLoginLocal) {
              const allAccounts = instance.getAllAccounts();

              if (allAccounts?.length) {
                instance?.logoutPopup();
              }
            }
          })
          .catch(() => {
            alert({
              title: i18n.t("logoutFailed"),
              content: i18n.t("pleaseTryAgain"),
            })
              .then(() => {})
              .catch(() => {});
          });
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SEO title="Forbidden" />
      <Stack
        direction={lgUpMatched ? "row" : "column"}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100vh"
        padding={rem(12)}
        spacing={rem(24)}
        sx={{ backgroundColor: "white" }}
      >
        <Box width={lgUpMatched ? "50%" : "100%"} order={lgUpMatched ? 1 : 2}>
          <Typography type="DisplayXL" fontWeight={600} marginTop={rem(12)}>
            Forbidden
          </Typography>
          <Typography type="TextXL" marginTop={rem(24)}>
            You don&apos;t have permission to access this resource.
          </Typography>
          <Stack direction="row" gap={rem(12)} marginTop={rem(48)}>
            <Button
              size="xl"
              onClick={handleLogout}
              startIcon={<LogOut01Icon fontSize="small" />}
              variant="outlined"
            >
              Log out
            </Button>
          </Stack>
        </Box>
        <Box width={lgUpMatched ? "50%" : "100%"} order={lgUpMatched ? 2 : 1}>
          <img
            src={permissionCloudSrc}
            alt="Permission Denied"
            style={{
              width: "100%",
              aspectRatio: 480 / 350,
            }}
          />
        </Box>
      </Stack>
    </>
  );
};

export default IndexPage;
